module.exports = __webpack_public_path__ + "img/question.2ff9b4cf.svg";